




  
  <nz-layout class="layout">
    <nz-header style="z-index: 1;">
      <ul nz-menu nzMode="horizontal" nzTheme="dark">
      <li  [routerLink]="'hoofdscherm'" nz-menu-item>
        <i nz-icon nzType="home"></i>
        <span>Dima Gbeniet</span>
      </li>
      <li  [routerLink]="'deWoning'" nz-menu-item>
        <i nz-icon nzType="picture"></i>
        <span>
          De Woning</span>
      </li>
      <li  [routerLink]="'info'" nz-menu-item>
        <i nz-icon nzType="info-circle"></i>
        <span>
          Info</span>
      </li>
      <li  [routerLink]="'ligging'" nz-menu-item>
        <i nz-icon nzType="search"></i>
        <span>
          Ligging</span>
      </li>
      <li  [routerLink]="'contact'" nz-menu-item>
        <i nz-icon nzType="contacts"></i>
        <span>
          Contact</span>
      </li>
      <li  [routerLink]="'recensies'" nz-menu-item>
        <i nz-icon nzType="safety-certificate"></i>
        <span>
          Recensies</span>
      </li>
    </ul>
    </nz-header>
    <nz-content style="z-index: 0;">
      <ng-content></ng-content>
    </nz-content>
  </nz-layout>
  <footer class="footer-distributed">
  <div class="footer-left">
    <h3>Vakantiewoning<span> Dima Gbeniet</span></h3>

    <p class="footer-links">
      <a routerLink="hoofdscherm" class="link-1">Dima Gbeniet</a>

      <a routerLink="deWoning">De Woning</a>

      <a routerLink="info">Info</a>

      <a routerLink="ligging">Ligging</a>

      <a routerLink="contact">Contact</a>

      <a routerLink="recensies">Recensies</a>

    </p>

    <p class="footer-company-name">Dima Gbeniet &copy; 2021</p>
  </div>

  <div class="footer-center">
    <div>
      <i class="fa fa-map-marker"></i>
      <a href="https://www.google.com/maps/place/Vakantiehuis+DIMA+GBENIET/@51.1238131,2.6719386,17z/data=!3m1!4b1!4m5!3m4!1s0x47dcbd7230d3df7f:0x391686ca7425f734!8m2!3d51.1238131!4d2.6741273"
        target="_blank">
        <p style="color: #7395ae;">Yvonnelaan 25<br>8670 Oostduinkerke</p>
      </a>
    </div>

    <div>
      <i class="fa fa-phone"></i>
      <p><a class="link" href="tel:0478/80 80 98">0478/80 80 98</a></p>
    </div>

    <div>
      <i class="fa fa-envelope"></i>
      <p><a href="mailto:els@dima-gbeniet.be" class="link">els@dima-gbeniet.be</a></p>
    </div>
  </div>

  <div class="footer-right">
    <p class="footer-company-about">
      Heeft u nog vragen of opmerkingen, neem dan zeker contact met ons op.
    </p>
  </div>
</footer>